export function parseCurrencyInputToCents(value: FormDataEntryValue | null) {
  const raw = String(value ?? "")
    .trim()
    .replace(/[€\s\u00a0]/g, "");
  if (!raw) return null;

  let normalized = raw;
  if (raw.includes(",")) {
    normalized = raw.replace(/\./g, "").replace(",", ".");
  } else if (raw.includes(".")) {
    const groups = raw.split(".");
    normalized =
      groups.length > 2 || groups.at(-1)?.length === 3
        ? groups.join("")
        : raw;
  }

  const amount = Number(normalized);
  return Number.isFinite(amount) && amount >= 0
    ? Math.round(amount * 100)
    : null;
}

export function formatCurrencyInput(cents: number | null | undefined) {
  if (cents == null) return "";
  const [integer, decimals] = (cents / 100).toFixed(2).split(".");
  const grouped = integer.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  return decimals === "00" ? grouped : `${grouped},${decimals}`;
}
